import { applyAction } from "./appliers";
import type { MemoryFeastAction, MemoryFeastState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: MemoryFeastState;
  readonly accepted: boolean;
  readonly error?: string;
}

export function reduceGameState(
  state: MemoryFeastState,
  action: MemoryFeastAction,
): MemoryFeastState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: MemoryFeastState,
  action: MemoryFeastAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
